import { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { setSelectedSupplier } from "../redux-state/features/orderState";
import axios from "axios";
import urls from "../urls";
class SupplierSelect extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      isLoading: false,
      options: [],
    };
    this.placeholder = "إختيار المورّد ";
  }
  componentDidMount() {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    axios
      .get(urls.getSuppliers, {
        params: {
          faculty_id,
        },
      })
      .then((res) => {
        const options = res.data.results.map((obj) => ({
          value: obj.id,
          label: obj.full_name,
        }));
        this.setState({ options });
      });
  }
  noOptionsMessage = () => "لا توجد نتائج ";
  handleChange = (obj) => {
    this.props.setSelectedSupplier(obj);
  };
  render() {
    const { options, isLoading } = this.state;
    return (
      <Select
        isRtl
        options={options}
        isSearchable
        isLoading={isLoading}
        placeholder={this.placeholder}
        noOptionsMessage={this.noOptionsMessage}
        onChange={this.handleChange}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
            height: "38px",
            fontSize: "12px",
          }),
        }}
        isDisabled={this.props.selectedSupplier && this.props.canBeDisabled}
      />
    );
  }
}
SupplierSelect.defaultProps = {
  canBeDisabled: true,
};
const mapDispatchToProps = { setSelectedSupplier };
const mapStateToProps = (state) => ({
  selectedSupplier: state.orderState.selectedSupplier,
});
export default connect(mapStateToProps, mapDispatchToProps)(SupplierSelect);
